import { render } from "./SnehaSparshamVoApprove.vue?vue&type=template&id=6b69f5ba&scoped=true"
import script from "./SnehaSparshamVoApprove.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamVoApprove.vue?vue&type=script&lang=js"

import "./SnehaSparshamVoApprove.vue?vue&type=style&index=0&id=6b69f5ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b69f5ba"]])

export default __exports__